import { useTargetedModel } from '@cotera/client/v0/actions/framework';
import type { WorkflowTriggerViewData } from './components/trigger/types';
import {
  resolveTriggerRenderableNode,
  useWorkflowRenderCatalog,
  type WorkflowGraphNodeViewModelHandle,
} from './workflow-render-catalog';
import { WorkflowModel } from './workflow.model';

/**
 * Resolves the per-entity view model for a workflow trigger on the canvas.
 */
export function useWorkflowTriggerViewModel(
  trigger: WorkflowTriggerViewData
): WorkflowGraphNodeViewModelHandle | null {
  const catalog = useWorkflowRenderCatalog();
  const workflowModel = useTargetedModel(WorkflowModel);

  if (workflowModel === null) {
    return null;
  }
  const entry = resolveTriggerRenderableNode(catalog, trigger);
  if (entry.models === undefined) {
    return null;
  }
  const entityId = trigger.id;
  if (entityId === '') {
    return null;
  }
  return {
    descriptorKey: entry.key,
    entityId,
    model: workflowModel.getRenderableNodeModel(entry.key, entityId),
  };
}
